import axios from "axios";

async function getDataPartners() {
    const apiURL = "https://api-ekata.ekata.id/api/partners";

  return await axios
    .get(apiURL).then((response) => {
        console.log("Partners : ",response.data.data);
        return response.data.data;
    }).catch((error) => {
        console.log(error);
        return [
            {
                id: 1,
                title: "Data Not Found",
                content: "Data Not Found",
            },
        ];
    });
}

export { getDataPartners };